export function jsonSafeParse<T extends Record<string, unknown>>(jsonString?: string | null): T | null {
  if (!jsonString) return null
  try {
    return JSON.parse(jsonString)
  } catch {
    return null
  }
}
